import Vue from  'vue'
import Router from 'vue-router'
import Principal from './views/principal.vue'
import Regulariza from './views/regulariza.vue'
import CadEstados from './views/cadestados.vue'
import CadMunicipios from './views/cadmunicipios.vue'
import CadBairros from './views/cadbairros.vue'
import CadFiliais from './views/cadfiliais'
import CadUsuariosManager from './views/cadusuariosmanager'
import CadUsuarios_Sac from './views/cadusuarios_sac'
import CadProdutos from './views/cadprodutos'
import CadGruposUsuarios from './views/cadgruposusuarios'
import CadMarcas from './views/cadmarcas'
import CadGrupos from './views/cadgrupos'
import CadSubgrupos from './views/cadsubgrupos'
import CadSetores from './views/cadsetores'
import CadLocalizacoes from './views/cadlocalizacoes'
import CadUnidades from './views/cadunidades'
import CadNcms from './views/cadncm'
import CadCests from './views/cadcest'
import CadClassesImpostos from './views/cadclassesimpostos'
import CadTabelasprecos from './views/cadtabelasprecos'
import CadFornecedores from './views/cadfornecedores'
import CadClientes from './views/cadclientes'
import CadPlanospagamento  from './views/cadplanospagamento'
import CadServicos from './views/cadservicos'
import CadTecnicos from './views/cadtecnicos'
import CadCobradores from './views/cadcobradores'
import CadMotoristas from './views/cadmotoristas'
import CadTransportadoras from './views/cadtransportadoras'
import CadVendedores from './views/cadvendedores'
import CadVeiculos from './views/cadveiculos'
import CadBandeirascredito from './views/cadbandeirascredito'
import CadTiposcobranca from './views/cadtiposcobranca'
import CadFormaspagamento from './views/cadformaspagamento'
import CadEstoques from './views/cadestoques'
import CadSituacoescheques from './views/cadsituacoescheques'
import CadCfops from './views/cadcfops'
import CadPedidosvenda from './views/cadpedidosvenda'
import CadNotasfiscais from './views/cadnotasfiscais'
import CadInformacoescomplementares from './views/cadinformacoescomplementares'
import CadTitulosreceber from './views/cadtitulosreceber'
import CadPdvs from './views/cadpdvs'
import CadLancamentospdvs from './views/cadlancamentospdvs'
import CadBancos from './views/cadbancos'
import CadContasbancarias from './views/cadcontasbancarias'
import CadCobrancasbancarias from './views/cadcobrancasbancarias'
import CadRetornosbancarios from './views/cadretornosbancarios'
import CadTransferenciasfiliais from './views/cadtransferenciasfiliais'
import CadNotasfornecedores from './views/cadnotasfornecedores'
import CadTitulospagar from './views/cadtitulospagar'
import RelEstoque from './views/relestoque'
import RelVendas from './views/relvendas'
import CadGrupossaidaspdv from './views/cadgrupossaidaspdv'
import CadContas from './views/cadcontas'
import CadCentroscustos from './views/cadcentroscustos'
import CadProvedorescustos from './views/cadprovedorescustos'
import CadHistoricospadroes from './views/cadhistoricospadroes'
import CadGruposplanos from './views/cadgruposplanoscontas'
import CadLancamentosfluxo from './views/cadlancamentosfluxo'
import CadConferencias from './views/cadconferencias'
import CadNaturezasoperacoes from './views/cadnaturezasoperacoes'
import CadCotacoes from './views/cadcotacoes'
import CadPedidoscompra from './views/cadpedidoscompra'
import VendaExterna from './views/vendaexterna'
import CadChecklist from './views/cadchecklist'
import CadPerfilfluxo from './views/cadperfilfluxocaixa'
import RelDemonstrativoresultados from './views/reldemonstrativoresultados' 
import CadFormulas from './views/cadformulas'
import CadOrdensproducao from './views/cadordensproducao'
import CadCategorias from './views/cadcategorias'
import CadRotas from './views/cadrotas'
import CadRecibos from './views/cadrecibos'
import CadRenegociacoes from './views/cadrenegociacoes'
import CadGuiasrotas from './views/cadguiasrotas'
import CadGarantias from './views/cadgarantiasfor.vue'
import Caddesossa from './views/caddesossa'
import Manutencao from './views/manutencao.vue'
import Payment from './components/Payment.vue';
Vue.use(Router)
export default new Router({
    //mode: 'history',//à princípio para remover a # da url da rota
    routes: [
        {
            path: '/',
            name: 'principal',
            component: Principal
        },
        {
            path: '/cadestados',
            name: 'cadestados',
            component: CadEstados
        },
        {
            path: '/cadmunicipios',
            name: 'cadmunicipios',
            component: CadMunicipios
        },
        {
            path: '/cadbairros',
            name: 'cadbairros',
            component: CadBairros
        },
        {
            path: '/cadusuarios_sac',
            name: 'cadusuarios_sac',
            component: CadUsuarios_Sac
        },
        {
            path: '/cadfiliais',
            name: 'cadfiliais',
            component: CadFiliais
        },        
        {
            path: '/cadusuariosmanager',
            name: 'cadusuariosmanager',
            component: CadUsuariosManager
        },
        {
            path: '/cadfornecedores',
            name: 'cadfornecedores',
            component: CadFornecedores
        },        
        {
            path: '/cadprodutos',
            name: 'cadprodutos',
            component: CadProdutos
        },
        {
            path: '/cadclientes',
            name: 'cadclientes',
            component: CadClientes
        },
        {
            path: '/cadgruposusuarios',
            name: 'cadgruposusuarios',
            component: CadGruposUsuarios
        },
        {
            path: '/cadmarcas',
            name: 'cadmarcas',
            component: CadMarcas
        },
        {
            path: '/cadgrupos',
            name: 'cadgrupos',
            component: CadGrupos
        },
        {
            path: '/cadsubgrupos',
            name: 'cadsubgrupos',
            component: CadSubgrupos
        },
        {
            path: '/cadsetores',
            name: 'cadsetores',
            component: CadSetores
        },
        {
            path: '/cadlocalizacoes',
            name: 'cadlocalizacoes',
            component: CadLocalizacoes
        },
        {
            path: '/cadtabelasprecos',
            name: 'cadtabelasprecos',
            component: CadTabelasprecos
        },
        {
            path: '/cadunidades',
            name: 'cadunidades',
            component: CadUnidades
        },
        {
            path: '/cadncm',
            name: 'cadncm',
            component: CadNcms
        },
        {
            path: '/cadclassesimpostos',
            name: 'cadclassesimpostos',
            component: CadClassesImpostos
        },
        {
            path: '/cadinformacoescomplementares',
            name: 'cadinformacoescomplementares',
            component: CadInformacoescomplementares
        },        
        {
            path: '/cadcest',
            name: 'cadcest',
            component: CadCests
        },
        {
            path: '/cadplanospagamento',
            name: 'cadplanospagamento',
            component: CadPlanospagamento
        },
        {
            path: '/cadservicos',
            name: 'cadservicos',
            component: CadServicos
        },
        {
            path: '/cadtecnicos',
            name: 'cadtecnicos',
            component: CadTecnicos
        },
        {
            path: '/cadcobradores',
            name: 'cadcobradores',
            component: CadCobradores
        },
        {
            path: '/cadmotoristas',
            name: 'cadmotoristas',
            component: CadMotoristas
        },
        {
            path: '/cadtransportadoras',
            name: 'cadtransportadoras',
            component: CadTransportadoras
        },        
        {
            path: '/cadvendedores',
            name: 'cadvendedores',
            component: CadVendedores
        },        
        {
            path: '/cadveiculos',
            name: 'cadveiculos',
            component: CadVeiculos
        },
        {
            path: '/cadbandeirascredito',
            name: 'cadbandeirascredito',
            component: CadBandeirascredito
        },
        {
            path: '/cadtiposcobranca',
            name: 'cadtiposcobranca',
            component: CadTiposcobranca
        },
        {
            path: '/cadformaspagamento',
            name: 'cadformaspagamento',
            component: CadFormaspagamento
        },
        {
            path: '/cadestoques',
            name: 'cadestoques',
            component: CadEstoques
        },
        {
            path: '/cadsituacoescheques',
            name: 'cadsituacoescheques',
            component: CadSituacoescheques
        },
        {
            path: '/cadcfops',
            name: 'cadcfops',
            component: CadCfops
        },
        {
            path: '/cadpedidosvenda',
            name: 'cadpedidosvenda',
            component: CadPedidosvenda
        },
        {
            path: '/cadnotasfiscais',
            name: 'cadnotasfiscais',
            component: CadNotasfiscais
        },
        {
            path: '/cadtitulosreceber',
            name: 'cadtitulosreceber',
            component: CadTitulosreceber
        },
        {
            path: '/cadpdvs',
            name: 'cadpdvs',
            component: CadPdvs
        },
        {
            path: '/cadlancamentospdvs',
            name: 'cadlancamentospdvs',
            component: CadLancamentospdvs
        },
        {
            path: '/cadbancos',
            name: 'cadbancos',
            component: CadBancos
        },
        {
            path: '/cadcontasbancarias',
            name: 'cadcontasbancarias',
            component: CadContasbancarias
        },
        {
            path: '/cadcobrancasbancarias',
            name: 'cadcobrancasbancarias',
            component: CadCobrancasbancarias
        },
        {
            path: '/cadretornosbancarios',
            name: 'cadretornosbancarios',
            component: CadRetornosbancarios
        },
        {
            path: '/cadnotasfornecedor',
            name: 'cadnotasfornecedores',
            component: CadNotasfornecedores
        },        
        {
            path: '/cadtransferenciasfiliais',
            name: 'cadtransferenciasfiliais',
            component: CadTransferenciasfiliais
        },
        {
            path: '/cadtitulospagar',
            name: 'cadtitulospagar',
            component: CadTitulospagar
        },
        {
            path: '/relestoque',
            name: 'relestoque',
          //  component: RelEstoque
            component: Manutencao
        },
        {
            path: '/relvendas',
            name: 'relvendas',
            //component: RelVendas
            component: Manutencao
        },
        {
            path: '/cadgrupossaidaspdv',
            name: 'cadgrupossaidaspdv',
            component: CadGrupossaidaspdv
        },
        {
            path: '/cadcontas',
            name: 'cadcontas',
            component: CadContas
        },
        {
            path: '/cadcentroscustos',
            name: 'cadcentroscustos',
            component: CadCentroscustos
        },
        {
            path: '/cadprovedorescustos',
            name: 'cadprovedorescustos',
            component: CadProvedorescustos
        },
        {
            path: '/cadhistoricospadroes',
            name: 'cadhistoricospadroes',
            component: CadHistoricospadroes
        },
        {
            path: '/cadnaturezasoperacoes',
            name: 'cadnaturezasoperacoes',
            component: CadNaturezasoperacoes
        },
        {
            path: '/cadgruposplanos',
            name: 'cadgruposplanos',
            component: CadGruposplanos
        },
        {
            path: '/cadlancamentosfluxo',
            name: 'cadlancamentosfluxo',
            component: CadLancamentosfluxo
        },
        {
            path: '/cadconferencias',
            name: 'cadconferencias',
            component: CadConferencias
        },
        {
            path: '/cadcotacoes',
            name: 'cadcotacoes',
            component: CadCotacoes
        },
        {
            path: '/cadpedidoscompra',
            name: 'cadpedidoscompra',
            component: CadPedidoscompra
        },
        {
            path: '/vendaexterna',
            name: 'vendaexterna',
            component: VendaExterna
        },
        {
            path: '/cadchecklist',
            name: 'cadchecklist',
            component: CadChecklist
        },
        {
            path: '/regulariza',
            name: 'regulariza',
            component: Regulariza
        },
        {
            path: '/cadperfilfluxo',
            name: 'cadperfilfluxo',
            component: CadPerfilfluxo
        },
        {
            path: '/reldemonstrativoresultados',
            name: 'reldemonstrativoresultados',
            component: RelDemonstrativoresultados
        },
        {
            path: '/cadformulas',
            name: 'cadformulas',
            component: CadFormulas
        },
        {
            path: '/cadordensproducao',
            name: 'cadordensproducao',
            component: CadOrdensproducao
        },
        {
            path: '/cadcategorias',
            name: 'cadcategorias',
            component: CadCategorias
        },
        {
            path: '/cadrotas',
            name: 'cadrotas',
            component: CadRotas
        },
        {
            path: '/cadrecibos',
            name: 'cadrecibos',
            component: CadRecibos
        },
        {
            path: '/cadrenegociacoes',
            name: 'cadrenegociacoes',
            component: CadRenegociacoes
        },
        {
            path: '/cadguiasrotas',
            name: 'cadguiasrotas',
            component: CadGuiasrotas
        },
        { 
            path: '/cadgarantias',
            name: 'cadgarantias',
            component: CadGarantias
        },
        {
            path: '/caddesossa',
            name: 'caddesossa',
            component: Caddesossa
        },
        {
            path: '/payment/:type',
            name: 'Payment',
            component: Payment
        }        
    ]

})